import React from 'react';
import { FetchStatus } from '../../../../util/FetchStatus';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import { ExtraCard } from '../jsx/ExtraCard';
export const InternetDeviceInstallation = (props) => {
    const { offer } = props;
    const { internetCalculatorExtraCardsState, secureNetCalculatorExtraCardsState, isSecureNet } = useInternetCalculator();
    const slugPrefix = 'devices-and-installation';
    const customerPrefix = isSecureNet ? '-b2b' : '';
    const getSlug = () => {
        switch (offer.technology) {
            case '5GNR':
                return `${slugPrefix}${customerPrefix}-5g`;
            case 'LTE':
                return `${slugPrefix}${customerPrefix}-4g`;
            default:
                return `${slugPrefix}${customerPrefix}-fix`;
        }
    };
    if (FetchStatus.FETCHED !== (isSecureNet ? secureNetCalculatorExtraCardsState.status : internetCalculatorExtraCardsState === null || internetCalculatorExtraCardsState === void 0 ? void 0 : internetCalculatorExtraCardsState.status)) {
        return null;
    }
    return React.createElement(ExtraCard, { slug: getSlug() });
};
